import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const PUBLIC_QRCODE: AppRouteRecordRaw = {
  path: '/public-qrcode',
  name: 'public-qrcode',
  component: DEFAULT_LAYOUT,
  redirect: '/public-qrcode/index',
  meta: {
    locale: '公共二维码管理',
    icon: 'icon-qrcode',
    requiresAuth: true,
    order: 9,
  },
  children: [
    {
      path: 'index',
      name: 'PublicQrCodeManagement',
      component: () => import('@/views/public-qrcode/index.vue'),
      meta: {
        locale: '公共二维码管理',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default PUBLIC_QRCODE;
